import { monthOptions } from "../utils/date.utils"

export const modifyCommonDropDownData = (data: any[]) => {
    if (Array.isArray(data) && data?.length > 0) {
        const formatedData = data.map((item) => {
            return { label: item?.data?.name, id: item?.header?.id }
        })
        return formatedData
    }
    return []
}

export const filterMonthDataById = (filterValue: any, type: string) => {
    if (filterValue) {
        const filteredItem: any = monthOptions.find((item) =>
            type === "id" ? item?.id === filterValue : item?.label === filterValue
        );
        const monthFilterValue = type === "id" ? filteredItem?.label : filteredItem?.id
        return filteredItem ? monthFilterValue : "";
    }
    return ''
};

export const downloadFile = (fileUrl: any) => {
    if (fileUrl) {
        try {
            const fileURL = fileUrl
            const fileName = fileUrl.split('/').pop().split('?')[0].split('#')[0];

            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', fileName);
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log("file download error:", error)
        }
    }
    else {
        console.log("cannot load file")
    }
}

export const downloadVideoFile = async (videofileUrl: string) => {
    if (videofileUrl) {
        try {
            const fileName = decodeURIComponent(videofileUrl?.split('/')?.pop() ?? 'video.mp4');

            const link = document.createElement('a');
            link.href = videofileUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log("video file download error:", error)
        }
    }
    else {
        console.log('file url not exists.');
    }
}
